import { render, staticRenderFns } from "./CopilotChat.vue?vue&type=template&id=98570872&scoped=true"
import script from "./CopilotChat.vue?vue&type=script&lang=js"
export * from "./CopilotChat.vue?vue&type=script&lang=js"
import style0 from "./CopilotChat.vue?vue&type=style&index=0&id=98570872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98570872",
  null
  
)

export default component.exports